import { render, staticRenderFns } from "./WorkplacePendingActivationsList.vue?vue&type=template&id=87006780&"
import script from "./WorkplacePendingActivationsList.vue?vue&type=script&lang=js&"
export * from "./WorkplacePendingActivationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports